export class FormSinistreModel {
  natureSinistre36DerniersMois: string;
  dateSinistre36DerniersMois: string;
  isDelitDeFuiteSinistre36DerniersMois: string;
  isInterventionForceDeLOrdreSinistres36DerniersMois: string;
  poursuiteTribunalPoliceSinistres36DerniersMois: string;
  isPresenceTiersSinistres36DerniersMois: string;
  constructor() {}
}
